import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { v2Route } from "~/v2/routes";

import { DataSourceTemplateDetail } from "./components/DataSourceTemplateDetail";
import { DataSourceTemplatesContainer } from "./components/dataSourceTemplates.container";

function DataSourceTemplatesLoading() {
  return <div className="mx-auto max-w-[var(--content-max)] p-8 text-14-regular text-fg-3">…</div>;
}

function DataSourceTemplateDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.dataSourceTemplates.detail);
  const navigate = useNavigate();
  return (
    <Suspense fallback={<DataSourceTemplatesLoading />}>
      <DataSourceTemplateDetail dataSourceTemplateId={id} onBack={() => navigate("..")} />
    </Suspense>
  );
}

export function DataSourceTemplatesRoutes() {
  return (
    <Suspense fallback={<DataSourceTemplatesLoading />}>
      <Routes>
        <Route index element={<DataSourceTemplatesContainer />} />
        <Route path=":id" element={<DataSourceTemplateDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
